export const DOCUMENTATION_STATUS = {
    START: "START",
    PENDING: "PENDING"
};

export const DocumentationInfo = {
    [DOCUMENTATION_STATUS.START]: {
        description: "Get your documents ready to sell your car quickly.",
        ctaText: "Get started"
    },
    [DOCUMENTATION_STATUS.PENDING]: {
        description: "Get your documents ready to sell your car quickly.",
        ctaText: "Complete documentation"
    }
};
